import * as betprofessor from './CompetitionsMatchCard.styles.betprofessor';
import * as sterlingparker from './CompetitionsMatchCard.styles.sterlingparker';
import * as volcanobet from './CompetitionsMatchCard.styles.volcanobet';
import * as junglebet from './CompetitionsMatchCard.styles.junglebet';
import * as puntgenie from './CompetitionsMatchCard.styles.puntgenie';
import * as fiestabet from './CompetitionsMatchCard.styles.fiestabet';
import * as puntcity from './CompetitionsMatchCard.styles.puntcity';
import * as betroyale from './CompetitionsMatchCard.styles.betroyale';
import * as juicybet from './CompetitionsMatchCard.styles.juicybet';
import * as goldenrush from './CompetitionsMatchCard.styles.goldenrush';
import * as vikingbet from './CompetitionsMatchCard.styles.vikingbet';
import * as questbet from './CompetitionsMatchCard.styles.questbet';
import * as wellbet from './CompetitionsMatchCard.styles.wellbet';
import * as betgalaxy from './CompetitionsMatchCard.styles.betgalaxy';
import * as sugarcastle from './CompetitionsMatchCard.styles.sugarcastle';
import * as oldgill from './CompetitionsMatchCard.styles.oldgill';
import * as buffalobet from './CompetitionsMatchCard.styles.buffalobet';
import * as titanbet from './CompetitionsMatchCard.styles.titanbet';
import * as gigabet from './CompetitionsMatchCard.styles.gigabet';
import * as slambet from './CompetitionsMatchCard.styles.slambet';
import * as betstride from './CompetitionsMatchCard.styles.betstride';
import * as templebet from './CompetitionsMatchCard.styles.templebet';
import * as goldenbet888 from './CompetitionsMatchCard.styles.goldenbet888';
import * as hyperbet from './CompetitionsMatchCard.styles.hyperbet';
import * as bet777 from './CompetitionsMatchCard.styles.bet777';
import * as chromabet from './CompetitionsMatchCard.styles.chromabet';
import * as bet575 from './CompetitionsMatchCard.styles.bet575';
import * as betblast from './CompetitionsMatchCard.styles.betblast';
import * as pyramidbet from './CompetitionsMatchCard.styles.pyramidbet';
import * as magnumbet from './CompetitionsMatchCard.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  sterlingparker,
  volcanobet,
  junglebet,
  puntgenie,
  fiestabet,
  puntcity,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  betgalaxy,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
